import * as React from "react"
import {
  SimpleForm,
  TextInput,
  SelectInput,
  DateTimeInput,
  email,
  SaveButton,
  DeleteWithConfirmButton,
  Toolbar,
  useRecordContext
} from "react-admin"
import { useFormContext } from 'react-hook-form';
import { Grid, Box } from "@mui/material"
import { useState } from "react"

const ContactToolbar = ({formType}) => {
  return (
    <Toolbar>
      <Box display="flex" justifyContent="space-between" width="100%">
        {/* 儲存按鈕 (始終顯示) */}
        <SaveButton />
        {/*
          條件渲染刪除按鈕：
          1. 只在編輯模式顯示 (formType === "edit")
        */}
        { formType === "edit" && (
          <DeleteWithConfirmButton
            confirmTitle="確認刪除"
            confirmContent="您確定要刪除此帳號嗎？"
          />
        )}
      </Box>
    </Toolbar>
  );
};

const validateForm = values => {
  const errors = {}
  if (!values.name) {
    errors.name = "ra.validation.required"
  }
  if (!values.email) {
    errors.email = "ra.validation.required"
  } else {
    const error = email()(values.email)
    if (error) {
      errors.email = error
    }
  }
  if (values.phone) {
    const phoneRegex = /^\d+$/
    if (!phoneRegex.test(values.phone)) {
      errors.phone = "請輸入有效的數字電話號碼"
    } else if (values.phone.length < 8 || values.phone.length > 10) {
      errors.phone = "電話號碼必須是8到10位數字"
    }
  }
  if (!values.requestType) {
    errors.requestType = "ra.validation.required"
  }
  if (!values.status) {
    errors.status = "ra.validation.required"
  }
  if (values.requestType !== "subscribe" && !values.message) {
    errors.message = "ra.validation.required"
  }
  if (values.status === "resolved" && !values.resolvedAt) {
    errors.resolvedAt = "ra.validation.required"
  }
  return errors
}

const ResolvedAtInput = ({readOnly}) => {
  const record = useRecordContext();

  if (record?.resolvedAt) readOnly = true;

  return (
    <DateTimeInput 
      source="resolvedAt"
      label="完成時間"
      readOnly={readOnly}
    />
  )
}

const StatusInput = ({setReadOnly}) => {
  const { setValue } = useFormContext();

  return (
    <SelectInput 
      source="status" 
      label="處理狀態" 
      isRequired
      choices={[
        { id: 'pending', name: '待處理' },
        { id: 'in_progress', name: '聯繫中' },
        { id: 'resolved', name: '已完成' },
        { id: 'closed', name: '結束' }
      ]} 
      onChange={(e) => {
        const isResolvedOrClosed = ["resolved"].includes(e.target.value);
        // setValue('resolvedAt', isResolvedOrClosed ? undefined : "");
        setReadOnly(!isResolvedOrClosed);
      }}
    />
  );
};

const ContactForm = ({formType}) => {
  const [readOnly, setReadOnly] = useState(true);

  return (
    <SimpleForm
      defaultValues={{
        name: "",
        email: "",
        phone: "",
        requestType: "subscribe",
        status: "pending",
        message: "",
        response: "",
        resolvedAt: "",
      }}
      validate={validateForm}
      toolbar={<ContactToolbar formType={formType} />}
    >
      <Grid container width={{ xs: "80%", xl: 800 }} spacing={2}>
        <Grid item xs={12} sm={4}>
          <SelectInput 
            source="requestType" 
            label="需求類型" 
            isRequired
            choices={[
              { id: 'subscribe', name: '訂閱我們' },
              { id: 'join', name: '加入我們' },
              { id: 'contact', name: '聯絡我們' },
              { id: 'become_partner', name: '成為廠商' }
            ]} 
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <StatusInput setReadOnly={setReadOnly} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <ResolvedAtInput readOnly={readOnly} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextInput autoFocus source="name" label="客戶名稱" isRequired />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextInput source="email" label="Email" isRequired />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextInput source="phone" label="聯絡電話" />
        </Grid>
        <Grid item xs={12}>
          <TextInput source="message"
            label="詳細內容" 
            multiline
            rows={4} // 設定多行的行數
          />
        </Grid>
        <Grid item xs={12}>
          <TextInput 
            source="response"
            label="紀錄備註" 
            multiline
            rows={4}
          />
        </Grid>
      </Grid>
    </SimpleForm>
  )
}

export default ContactForm